module.exports = __webpack_public_path__ + "img/calendar-arrow-down.d51ddf3f.svg";